<div class="error-container">
  <mat-icon class="primaryColor warning-icon">warning</mat-icon>
  <h1 class="primaryColor">Something went wrong</h1>
  <p class="bold">Sorry, something went wrong. Please try again.</p>
</div>
